import type { IconNode } from '../types';

/**
 * @name nepali-rupee
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTggMTYuMTczIEE0Ljc0IDQuNzQgMCAwIDAgMTMuNDk2IDguMDA1IiAvPgogIDxwYXRoIGQ9Ik00IDMgTDIwIDMiIC8+CiAgPHBhdGggZD0iTTUgMTMgTDEzLjUgMjEiIC8+CiAgPHBhdGggZD0iTTUgMTMgTDkgMTMiIC8+CiAgPHBhdGggZD0iTTggMTMgQzE1LjUgMTMgMTQuNjY3IDMgOCAzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/nepali-rupee
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const NepaliRupee: IconNode = [
  ['path', { d: 'M18 16.173 A4.74 4.74 0 0 0 13.496 8.005' }],
  ['path', { d: 'M4 3 L20 3' }],
  ['path', { d: 'M5 13 L13.5 21' }],
  ['path', { d: 'M5 13 L9 13' }],
  ['path', { d: 'M8 13 C15.5 13 14.667 3 8 3' }],
];

export default NepaliRupee;
